import React from 'react';
import addModifiers from 'utils/add_modifiers';
import AlertBox, { Heading, SubHeading } from 'components/shared/AlertBox';

const ERROR_TYPES = {
  INVALID_AUDIO_FILE: 'invalid_file_format_audio',
  INVALID_FILE: 'invalid_file_format_all',
  INVALID_VIDEO_FILE: 'invalid_file_format_video',
  ERROR_STARTING_RECORDING_DEVICES: 'error starting recording devices',
  EXTENSION_REQUIRED: 'extension_required',
  SIZE_LIMIT_EXCEEDED: 'size_limit_exceeded',
  VIDEO_TOO_SMALL: 'video_too_small',
  UNIDENTIFIED_CODEC: 'unidentified_codec',
};

class ErrorModal extends React.Component {
  constructor(props) {
    super(props);

    this.errorMessageText = this.errorMessageText.bind(this);
    this.submitButtonText = this.submitButtonText.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  /**
   * This method provides a common interface for displaying various recording
   * errors encountered by the media recording provider
   */
  errorMessageText() {
    switch (this.props.errorType) {
      case ERROR_TYPES.INVALID_AUDIO_FILE:
        return t('lessons.editor.media_recording.import_error_audio');
      case ERROR_TYPES.INVALID_VIDEO_FILE:
        return t('lessons.editor.embeds.video.import_error');
      case ERROR_TYPES.INVALID_FILE:
        return t('lessons.editor.media_recording.import_error_all');
      case ERROR_TYPES.EXTENSION_REQUIRED:
        return t(
          'questions.question.media_recording.errors.extension_required.message',
        );
      case ERROR_TYPES.ERROR_STARTING_RECORDING_DEVICES:
        return t(
          'questions.question.media_recording.errors.error_starting_recording_devices.message',
        );
      case ERROR_TYPES.SIZE_LIMIT_EXCEEDED:
        return t('lessons.editor.embeds.video.size_limit_exceeded');
      case ERROR_TYPES.VIDEO_TOO_SMALL:
        return t('lessons.editor.embeds.video.video_too_small');
      case ERROR_TYPES.UNIDENTIFIED_CODEC:
        return t('lessons.editor.embeds.video.unidentified_codec');
      default:
        return t('questions.question.media_recording.errors.default.message');
    }
  }

  submitButtonText() {
    if (this.props.errorType === ERROR_TYPES.EXTENSION_REQUIRED) {
      return t(
        'questions.question.media_recording.errors.extension_required.submit_button',
      );
    }
    return t('questions.question.media_recording.errors.default.submit_button');
  }

  handleCancel() {
    this.props.onAction();
  }

  /**
   * This method provides a common interface for performing actions when a
   * Learner agrees to the modal conditions
   */
  handleSubmit() {
    if (this.props.errorType === ERROR_TYPES.EXTENSION_REQUIRED) {
      window.hippoWidget.installExtension();
    }

    // Ensure that any parent callbacks are called after the error specific logic
    // is handled
    this.props.onAction();
  }

  render() {
    const errorIsExtensionRequired =
      this.props.errorType === ERROR_TYPES.EXTENSION_REQUIRED;

    return (
      <div>
        <AlertBox>
          <Heading>
            {t('questions.question.media_recording.errors.default.heading')}
          </Heading>
          <SubHeading>{this.errorMessageText()}</SubHeading>
          <div className="d-f jc-e mt-24">
            {errorIsExtensionRequired && (
              <button
                type="button"
                className="u-linkBtn u-linkBtn--dark"
                children={t(
                  'questions.question.media_recording.errors.default.cancel_button',
                )}
                onClick={this.handleCancel}
              />
            )}
            <button
              type="button"
              className={`ml-16 ${addModifiers('NewButton', [
                'yellow',
                'tallAndWide',
              ])}`}
              children={this.submitButtonText()}
              onClick={this.handleSubmit}
            />
          </div>
        </AlertBox>
      </div>
    );
  }
}

export default ErrorModal;
